import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { CgLaptop } from "react-icons/cg";
import { useDispatch } from "react-redux";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import { clearGlobalFilterReducer } from "../../../../../data/redux/slice/globalFiltersSlice";
import { fetchAllUserList } from "../../../../../services/fetchListingData";
import { primaryColor } from "../../../../../utility/constants/colorManager";
import { STATUS_CODE_200 } from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomSelect from "../../../../components/main_comps/custom_select";

const CheckBoxWithName = ({ title, value, onChange, checked = false }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: 30,
        width: "auto",
        margin: "0px 10px",
      }}
    >
      <input
        type="checkbox"
        style={{
          height: 20,
          width: 20,
          marginRight: 20,
        }}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <p
        style={{
          fontSize: 14,
        }}
      >
        {title}
      </p>
    </div>
  );
};

const modififyDropdownData = (data) => {
  let arr = [];

  data &&
    data?.map((val, i) => {
      if (val.role !== "Reseller" && val.role !== "Client") {
        arr.push({
          value: val?.defaultAclList,
          label: val.role,
        });
      }
    });
  return arr;
};

function SelectManagement({
  data,
  onSuccess,
  onClickCancel,
  edit = false,
  role,
  aclFeatures,
  userId,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [selectedRole, setSelectedRole] = useState("");
  const [allRolesDropdown, setAllRolesDropdown] = useState([]);
  const [aclList, setAclList] = useState([]);
  const [aclListChecked, setAclListChecked] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const findAclById = (id) => {
    let obj = aclListChecked.findIndex((o) => o.aclId === id);

    return obj !== -1;
  };

  const findSubAclById = (id, aclId) => {
    const index = aclListChecked.findIndex((o) => o.aclId === aclId);

    if (index !== -1) {
      let obj = aclListChecked[index]?.subaclList?.findIndex(
        (o) => o.subAclId === id
      );
      return obj !== -1;
    } else return false;
  };

  const removeByAclId = (id) => {
    const filteredData = aclListChecked.filter((data) => data.aclId !== id);

    setAclListChecked(filteredData);
  };

  const removeBySubAclId = (aclId, id) => {
    const index = aclListChecked.findIndex((o) => o.aclId === aclId);
    const filteredData = aclListChecked[index]?.subaclList?.filter(
      (data) => data.subAclId !== id
    );

    let temp = aclListChecked[index];
    const filteredData1 = aclListChecked.filter((data) => data.aclId !== aclId);

    if (filteredData.length === 0) {
      setAclListChecked(filteredData1);
    } else {
      setAclListChecked([
        ...filteredData1,
        {
          aclName: temp.aclName,
          aclId: temp.aclId,
          subaclList: filteredData,
          aclValue: temp.aclValue,
        },
      ]);
    }
  };

  const addSubAclToArray = (aclId, id, name, value, path) => {
    const filteredData = aclListChecked.filter((data) => data.aclId === aclId);

    filteredData[0].subaclList.push({
      subAclName: name,
      subAclId: id,
      subAclValue: value,
      apiPath: path,
    });

    const filteredData1 = aclListChecked.filter((data) => data.aclId !== aclId);

    setAclListChecked([...filteredData1, ...filteredData]);
  };

  // auto check the checkbox based on roles
  const addRolesAclData = () => {
    if (selectedRole && selectedRole?.value) {
      let temp = [];
      selectedRole?.value?.map((acl) => {
        let subaclList = [];

        acl.subList.map((subacl) => {
          subaclList.push({
            subAclName: subacl.sub_acl_name,
            subAclId: subacl.sub_acl_id,
            subAclValue: subacl.sub_acl_value,
            apiPath: subacl.api_path_value,
          });
        });

        temp.push({
          aclId: acl.acl_id,
          aclName: acl.acl_name,
          subaclList,
          aclValue: acl.acl_value,
        });
      });

      setAclListChecked(temp);
    }
  };

  const fetchAllUiAcl = () => {
    ApiRequestGet.getAllAclForUi()
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          setAclList(response.data.acls);
        }
      })
      .catch((err) => {});
  };

  const fetchAllRoles = () => {
    ApiRequestGet.getAllRolesList()
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          setAllRolesDropdown(modififyDropdownData(response.data));
        }
      })
      .catch((err) => {});
  };

  const editUser = () => {
    ApiRequestPost.updateRolemanagement({
      role: selectedRole.label,
      aclList: aclListChecked,
      userId: userId,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          navigate("/role-management");
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const addUser = () => {
    setLoading(true);
    ApiRequestPost.createUser({
      firstName: data.firstName,
      lastName: data.lastName,
      role: selectedRole.label,
      mobileNumber: data.mobileNumber,
      email: data.email,
      internal: data.internal,
      aclList: aclListChecked,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
          dispatch(fetchAllUserList(1, 10));
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };

  // auto check the checkbox based on roles
  useEffect(() => {
    addRolesAclData();
  }, [selectedRole]);

  useEffect(() => {
    fetchAllRoles();
    fetchAllUiAcl();

    if (edit) {
      let temp = [];

      aclFeatures?.map((acl) => {
        let subaclList = [];

        acl?.subaclList?.map((subacl) => {
          subaclList.push({
            subAclName: subacl.sub_acl_name,
            subAclId: subacl.sub_acl_id,
            subAclValue: subacl.sub_acl_value,
            apiPath: subacl.api_path_value,
          });
        });

        temp.push({
          aclId: acl.acl_id,
          aclName: acl.acl_name,
          subaclList,
          aclValue: acl.acl_value,
        });
      });

      setAclListChecked(temp);
      setSelectedRole({ label: role, value: null });
    }
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: 700,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        maxWidth: "1000px",
        minWidth: "400px",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          height: 60,
          position: "absolute",
          top: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            height: "auto",
            height: 60,
            alignItems: "center",
          }}
        >
          <p
            style={{
              marginRight: 30,
              fontSize: 17,
              fontWeight: "600",
            }}
          >
            Permission Management
          </p>

          <CustomSelect
            value={selectedRole}
            onChange={(data) => {
              setSelectedRole(data);
            }}
            options={allRolesDropdown}
            style={{
              marginBottom: 0,
              minWidth: 300,
            }}
            placeholder="Assign Role"
          />
        </div>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          height: "80%",
          flexDirection: "column",
          overflow: "auto",
          marginTop: 60,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "15px 0px",
            border: "1px solid #F3F3F3",
            backgroundColor: "#F9F9FB",
            marginTop: "20px",
          }}
        >
          <div
            style={{
              margin: "0px 30px",
              width: 200,
              minWidth: 200,
            }}
          >
            <p>Tab</p>
          </div>
          <div
            style={{
              margin: "0px 0px",
            }}
          >
            <p>Actions</p>
          </div>
        </div>

        {aclList &&
          aclList?.map((obj, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0px 0px",
                padding: "15px 0px",
                borderBottom: "1px solid #F3F3F3",
                // pointerEvents: selectedRole ? "all" : "none",
              }}
            >
              <div
                style={{
                  margin: "0px 20px",
                  width: 200,
                  minWidth: 200,
                }}
              >
                <CheckBoxWithName
                  title={obj?.acl_name}
                  value={obj.acl_id}
                  onChange={() => {
                    if (findAclById(obj.acl_id)) {
                      removeByAclId(obj.acl_id);
                    } else {
                      let temp = [];
                      obj.aclList.forEach((subacl) => {
                        temp.push({
                          subAclName: subacl.sub_acl_name,
                          subAclId: subacl.sub_acl_id,
                          subAclValue: subacl.sub_acl_value,
                          apiPath: subacl.api_path_value,
                        });
                      });
                      setAclListChecked([
                        ...aclListChecked,
                        {
                          aclName: obj.acl_name,
                          aclId: obj.acl_id,
                          subaclList: temp,
                          aclValue: obj.acl_value,
                        },
                      ]);
                    }
                  }}
                  checked={findAclById(obj.acl_id)}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                {obj?.aclList &&
                  obj?.aclList.map((obj1, i1) => (
                    <CheckBoxWithName
                      key={i1}
                      title={obj1?.sub_acl_name}
                      value={obj1.sub_acl_id}
                      onChange={() => {
                        if (findSubAclById(obj1.sub_acl_id, obj.acl_id)) {
                          removeBySubAclId(obj.acl_id, obj1.sub_acl_id);
                        } else if (findAclById(obj.acl_id)) {
                          addSubAclToArray(
                            obj.acl_id,
                            obj1.sub_acl_id,
                            obj1.sub_acl_name,
                            obj1.sub_acl_value,
                            obj1.api_path_value
                          );
                        } else {
                          setAclListChecked([
                            ...aclListChecked,
                            {
                              aclName: obj.acl_name,
                              aclId: obj.acl_id,
                              aclValue: obj.acl_value,
                              subaclList: [
                                {
                                  subAclName: obj1.sub_acl_name,
                                  subAclId: obj1.sub_acl_id,
                                  subAclValue: obj1.sub_acl_value,
                                  apiPath: obj1.api_path_value,
                                },
                              ],
                            },
                          ]);
                        }
                      }}
                      checked={findSubAclById(obj1.sub_acl_id, obj.acl_id)}
                    />
                  ))}
              </div>
            </div>
          ))}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          padding: "15px 0px",
          marginTop: "10px",
          position: "absolute",
          bottom: 0,
        }}
      >
        <CustomButton
          title={"Cancel"}
          styles={{
            backgroundColor: "transparent",
            border: `1px solid ${primaryColor}`,
          }}
          textStyles={{ color: primaryColor }}
          onClick={onClickCancel}
        />
        <CustomButton
          title={"Save"}
          styles={{
            backgroundColor: primaryColor,
            border: `1px solid ${primaryColor}`,
            marginLeft: "20px",
          }}
          textStyles={{ color: "white" }}
          onClick={() => {
            if (edit) {
              editUser();
            } else {
              addUser();
            }
          }}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default SelectManagement;
